import {GetExamsStates} from 'domain/usecases/private/booking-flow/exams/get-exams-states';
import {RemoteGetExamsStates} from 'data/usecases/private/booking-flow/exams/remote-get-exams-states';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';
import {getFeatureFlagValue} from 'infra/http/utils/get-feature-flag-value';
import {FeaturesEnum} from 'presentation/constants/featuresFlagEnum';

export const makeGetExamsStates = (): GetExamsStates => {
	const isExamsLocationsStatesV3Enabled = getFeatureFlagValue(
		FeaturesEnum.PORTAL_FEATURE_EXAMS_LOCATIONS_STATES_V3,
	);

	const endpoint = isExamsLocationsStatesV3Enabled
		? BookingFlowEndPoints.examStatesV3
		: BookingFlowEndPoints.examStates;

	return new RemoteGetExamsStates(makeBFFApiUrl(endpoint), makeAuthorizeHttpClientDecorator());
};
